import SiderUser from "../../components/siderbarcomponentsUser";
import { useNavigate } from "react-router-dom";


const ConfiguracionCuenta = () => {
   const navigate= useNavigate();
  return (
    <div className="flex h-screen bg-gray-100">
      <SiderUser />

      <div className="p-8 bg-gray-100 min-h-screen w-full">
        <div className="bg-white shadow-lg rounded-lg pt-12 px-28 w-full h-[100%]">
          <h1 className="text-[22px] font-semibold text-textSubtitle mb-8">
            Configuración de mi cuenta
          </h1>

          <div className="flex items-center justify-between mb-8">
            <div>
              <ul className="flex space-x-4">
                <li className="pb-2 border-b-4 border-blue-500 text-[16px] font-medium text-textSubtitle mr-2">
                  Perfil
                </li>
                <li onClick={()=>navigate("/user/suscripcion/transaccion")} className="cursor-pointer pb-2 text-[16px] font-medium text-textTipic">
                  Suscripción
                </li>
              </ul>
            </div>
            <div className="flex items-center justify-center border border-gray-300 w-52 h-16 rounded-lg cursor-pointer">
                <h2 className="text-[16px] font-semibold text-textTipic">Suba su Logo</h2>
            </div>
          </div>

          <div className="mb-4">
            <h2 className="text-[28px] font-semibold text-textSubtitle mb-2">
              Expresso Belmira
            </h2>
            <p className=" mb-4 text-[16px] text-textSubtitle">
              Nor occidente Antioquia
            </p>
            <p className="mb-8 text-[16px] text-textTipic">
              Transporte Urbano sede principal Medellion
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Nombre Representante legal
              </label>
              <input
                type="text"
                name="nombre"
                placeholder="Ingrese Nombre"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>
            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Identificación
              </label>
              <input
                type="number"
                name="nombre"
                placeholder="Ingrese Identificación"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>

            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Correo electrónico
              </label>
              <input
                type="email"
                name="nombre"
                placeholder="Ingrese Email"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>
            <div className="w-full h-auto">
              <label className="text-[12px] text-textSubtitle font-medium">
                Número telefónico
              </label>
              <input
                type="number"
                name="nombre"
                placeholder="Ingrese Número"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[14px]"
                required
              />
            </div>

            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Dirección empresa
              </label>
              <input
                type="text"
                name="nombre"
                placeholder="Ingrese Email"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>
            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Password actual
              </label>
              <input
                type="password"
                name="nombre"
                placeholder="Ingrese Número"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>

            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Nuevo Password
              </label>
              <input
                type="password"
                name="nombre"
                placeholder="Ingrese Número"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>

            <div className="w-full h-auto">
              <label className="text-[13px] text-textSubtitle font-medium">
                Confirmar Password
              </label>
              <input
                type="password"
                name="nombre"
                placeholder="Ingrese Número"
                className="w-full border border-gray-300 p-4 rounded text-textTipic text-[15px]"
                required
              />
            </div>
          </div>

          <div className="flex justify-end space-x-4 mt-8">
            <button className="bg-white border border-bgSecundary text-textSecundary py-[13px] px-8 rounded-md font-semibold">
              Cancelar
            </button>
            <button className="bg-bgPrimary text-white py-[12px] px-4 rounded-md font-semibold">
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionCuenta;
